import { render, staticRenderFns } from "./VueSliderComp.vue?vue&type=template&id=47051630"
import script from "./VueSliderComp.vue?vue&type=script&lang=js"
export * from "./VueSliderComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports